import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import SuiButton from "components/SuiButton";
import useStyles from "../../styles";

function StepperActions({
  activeStep,
  stepsLength,
  isStepOptional,
  handleBack,
  handleSkip,
  handleNext,
  handleReset,
  isComplete,
  disableNext = false, // Nuevo prop
}) {
  const classes = useStyles();

  if (isComplete) {
    return (
      <Box className={classes.actionButtons}>
        <Box sx={{ flex: "1 1 auto" }} />
        <SuiButton onClick={handleReset} variant="gradient" color="info">
          Nueva Solicitud
        </SuiButton>
      </Box>
    );
  }

  return (
    <Box className={classes.actionButtons} sx={{ mt: 2 }}>
      <SuiButton
        color="inherit"
        disabled={activeStep === 0}
        onClick={handleBack}
        className={classes.backButton}
      >
        Atrás
      </SuiButton>
      <Box sx={{ flex: "1 1 auto" }} />
      {isStepOptional(activeStep) && (
        <SuiButton color="inherit" onClick={handleSkip} className={classes.skipButton}>
          Saltar
        </SuiButton>
      )}
      <SuiButton
        onClick={() => handleNext()}
        variant="gradient"
        buttonColor="dark"
        size="medium"
        color={activeStep === stepsLength - 1 ? "success" : "warning"}
        disabled={disableNext}
        sx={{
          opacity: disableNext ? 0.6 : 1,
          cursor: disableNext ? "not-allowed" : "pointer",
        }}
      >
        {activeStep === stepsLength - 1 ? "Finalizar" : "Siguiente"}
      </SuiButton>
    </Box>
  );
}

StepperActions.propTypes = {
  activeStep: PropTypes.number.isRequired,
  stepsLength: PropTypes.number.isRequired,
  isStepOptional: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleSkip: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  isComplete: PropTypes.bool.isRequired,
  disableNext: PropTypes.bool,
};

export default StepperActions;
